import { api } from "./api";

export const managerDashboardService = {
  fetchStats() {
    return api.get("/manager-dashboard-stats/");
  },
};

export default managerDashboardService;
